import React from 'react'
import Text from 'components/Text.js'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getNotesByIdWorkoutSelector from 'modules/workout/redux/selectors/get-notes-by-id/index.js'

export default function WorkoutNotesText ({ id }) {
  const notes = useSelector(getNotesByIdWorkoutSelector(id))

  return (
    <Text
      c='#151D21'
      fw={400}
      style={{
        marginBottom: STYLES_MARGIN.SMALL,
        whiteSpace: 'pre-wrap',
        lineHeight: '152.3%'
      }}
    >
      {notes}
    </Text>
  )
}
